type Severity = "success" | "error" | "warning" | "info";

type AnchorOrigin = {
  vertical: "top" | "bottom";
  horizontal: "left" | "center" | "right";
};

interface SnackState {
  open: boolean;
  message: string;
  severity: Severity;
  autoHideDuration: number;
  anchorOrigin: AnchorOrigin;
}

interface SnackOptions {
  autoHideDuration?: number;
  anchorOrigin?: AnchorOrigin;
}

type SnackListener = (state: SnackState) => void;

let snackState: SnackState = {
  open: false,
  message: "",
  severity: "success",
  autoHideDuration: 3000,
  anchorOrigin: { vertical: "bottom", horizontal: "center" },
};

let snackListeners: SnackListener[] = [];

export const snackService = {
  open(message: string, severity: Severity = "success", options: SnackOptions = {}): void {
    snackState = { ...snackState, open: true, message, severity, ...options };
    snackListeners.forEach((listener) => listener(snackState));
  },

  close(): void {
    snackState = { ...snackState, open: false };
    snackListeners.forEach((listener) => listener(snackState));
  },

  subscribe(listener: SnackListener): () => void {
    snackListeners.push(listener);
    return () => {
      snackListeners = snackListeners.filter((l) => l !== listener);
    };
  },
};